import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from "../../helpers/dictionary";

import { Enums } from "../common/enums";
import { OpDataType } from "../core/op-data-type";
import { OpFile } from "../core/op-file";

import { OpImportPluginParam } from "../util/op-import-plugin-param";
import { IJsonSerializable } from '../util/interfaces'

export class OpImportData implements IJsonSerializable {

    //#region Properties

    public fileName: string
    public importFile: OpFile
    public headers: string[]
    public data: any[][]
    public params: OpImportPluginParam[]

    //#endregion


    //#region Ctor

    constructor(opObj: any = null) {
        this.fromJSON(opObj)

        if (this.params == null) {
            this.params = []
        }

        if (this.headers == null) {
            this.headers = []
        }

        if (this.data == null) {
            this.data = []
        }
    }

    //#endregion


    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.fileName = opObj.FileName
            this.headers = opObj.Headers
            this.data = opObj.Data

            if (opObj.ImportFile != null) {
                this.importFile = new OpFile(opObj.ImportFile)
            }

            if (opObj.Params != null) {
                this.params = opObj.Params.map((paramObj: any) => { return new OpImportPluginParam(paramObj) })
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            FileName: this.fileName,
            ImportFile: this.importFile ? this.importFile.toJSON() : null,
            Headers: this.headers ? this.headers : null,
            Data: this.data ? this.data : null,
            Params: this.params ? this.params.map(data => { return data.toJSON() }) : null
        }
    }

    public static isType(obj: any): boolean {
        return obj && (<OpImportData>obj).fileName != undefined
            && (<OpImportData>obj).headers != undefined
            && (<OpImportData>obj).data != undefined
            && (<OpImportData>obj).params != undefined
    }
}